export const config = {
  title: "Bowman Sales and Services",
  meta: {
    description:
      "Bowman Sales and Services is a licensed, bonded handyman and property maintenance service in Oklahoma City, OK, providing everything from lawn care and repairs to cleaning, pressure washing, plumbing, electrical, and remodeling.",
    keywords: [
      "Bowman Sales and Services",
      "Oklahoma City handyman",
      "property maintenance OKC",
      "pressure washing Oklahoma City",
      "lawn care OKC"
    ],
    author: "Bowman Sales and Services",
    canonicalUrl: "https://handymancontractorbowmansalesandservices.net/",
  },
  sections: {
    header: { businessName: "Bowman Sales and Services" },
    sectionB: {
      heroTitle: "Bowman Sales and Services",
      heroSubtitle: "Trusted Handyman & Property Maintenance in Oklahoma City",
      learnAboutText: "View Services",
      phoneNumber: "4056284005",
      phoneLabel: "(405) 628‑4005",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2167217121/photo/worker-replace-aluminium-sliding-window-lock.jpg?s=612x612&w=0&k=20&c=XV3-Qbpd_NixsJ-w1HUZckX8AUXKbUN8PFDZ_2-a93U=",
      cardData: [
        {
          title: "Handyman Repairs",
          description:
            "General repairs, painting, plumbing, electrical, drywall, carpentry." },
        {
          title: "Lawn & Maintenance",
          description:
            "Lawn care, landscaping, gutter cleaning, pressure washing." },
        {
          title: "Commercial & Residential",
          description:
            "Janitorial services, carpet/upholstery cleaning & property upkeep." }
      ],
      description:
        "Locally owned since 1976, Bowman Sales and Services provides licensed, bonded handyman and maintenance services throughout Oklahoma City. Services range from repairs and remodeling to cleaning, lawn care, power washing and more.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive property maintenance and repair solutions for homes and businesses.",
      cards: [
        {
          title: "Lawn & Landscaping",
          description: "Mowing, edging, mulching, cleanup.",
          imageSrc: "https://media.istockphoto.com/id/2165553766/photo/young-hispanic-latino-man-using-a-hand-shovel-to-dig-holes-in-soil-for-a-flowerbed-in-a.jpg?s=612x612&w=0&k=20&c=kBzVQvpnzk_rxQgh9s1ae0579ibheY3uEIEj3OLLCbc=",
          imageAlt: "Lawn Care",
        },
        {
          title: "Pressure Washing",
          description: "Driveways, siding, decks, and patio cleaning.",
          imageSrc: "https://media.istockphoto.com/id/2150556211/photo/half-of-the-stone-slabs-were-cleaned-with-a-high-pressure-cleaner-before-and-afterwards.jpg?s=612x612&w=0&k=20&c=N9GDsNEsJWYEQy8kiA0JhSauch92yD3i-0kGaHVRtT0=",
          imageAlt: "Pressure Washing",
        },
        {
          title: "Handyman & Repairs",
          description: "Painting, plumbing, electrical, flooring & more.",
          imageSrc: "https://media.istockphoto.com/id/2088322665/photo/construction-worker-installing-ceiling-frame-at-site.jpg?s=612x612&w=0&k=20&c=MN63LMJozQjGugIjTiwJ6wCy46F8ZErlSy5XYadsQqQ=",
          imageAlt: "Handyman Repairs",
        },
      ],
      otherServicesTitle: "Additional Offerings",
      otherServicesList: [
        "Carpet & Upholstery Cleaning",
        "Gutter Cleaning",
        "Janitorial Services",
        "Small Demolition & Restoration",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://handymancontractorbowmansalesandservices.net/public/images/content/flogo.png",
        alt: "Bowman Sales and Services Team",
      },
      aboutText: [
        "Bowman Sales and Services has been serving Oklahoma City since 1976 as a licensed, bonded handyman and maintenance provider.",
        "With over 5,000 hours of service and a reputation for responsive, quality work, we support both residential and commercial customers.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Bowman Sales and Services Logo",
      businessName: "Bowman Sales and Services",
      contact: {
        phone: "4056284005",
        phoneLabel: "(405) 628‑4005",
        email: "bobb123b@yahoo.com",
        website:
          "https://handymancontractorbowmansalesandservices.net/",
        address: "Oklahoma City, OK",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "Oklahoma City, OK",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.7690187565525!2d-97.5164282!3d35.4675602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87b2172701d5e7fd%3A0x93e4ec2b2f3c7f8a!2sOklahoma%20City%2C%20OK!5e0!3m2!1sen!2sus!4v1718800000000!5m2!1sen!2sus",
    }
  },
};

export default config;
